"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _contentType = _interopRequireDefault(require("content-type"));
var _assets = require("../../utils/assets");
var _arrays = require("../../utils/arrays");
var _objects = require("../../utils/objects");
var assetsActions = _interopRequireWildcard(require("../assets/actionTypes"));
var portalsActions = _interopRequireWildcard(require("../portals/actionTypes"));
var actions = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {},
  ui: {
    isLoading: false,
    isCreatingPage: false,
    hasUnsavedChanges: false,
    pageEditorState: {
      hasUnsavedChanges: false,
      groupId: null,
      assetId: null,
      version: null,
      pagePath: null,
      pageName: null,
      pageContent: null
    }
  }
};
function reducer() {
  var _state$data$versionPa2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var publishedVersion = (0, _assets.getGAMKey)(action);
  var draftVersion = "".concat(publishedVersion, "/draft");
  var versionPath = "".concat(action.isDraft ? draftVersion : publishedVersion);
  var getPreviewsPageContent = function getPreviewsPageContent() {
    var _state$data$versionPa;
    return (_state$data$versionPa = state.data[versionPath]) !== null && _state$data$versionPa !== void 0 && _state$data$versionPa[action.pagePath] ? state.data[versionPath][action.pagePath] : {
      path: action.pagePath,
      name: action.pagePath
    };
  };
  var pagePathContent;
  switch (action.type) {
    case portalsActions.FETCH_PORTAL_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread({}, (0, _objects.deepMerge)(state.data[versionPath] || {}, (0, _arrays.getHashMap)(action.data.pages, 'path')))))
      });
    case actions.FETCH_PAGE_HTML_SUCCESS:
      {
        var _targetType;
        pagePathContent = getPreviewsPageContent();
        var targetType;
        try {
          var _contentType$parse;
          targetType = (_contentType$parse = _contentType.default.parse(action.contentType)) === null || _contentType$parse === void 0 ? void 0 : _contentType$parse.type;
        } catch (_unused) {
          // do not set target type if parsing fails
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, _objectSpread(_objectSpread(_objectSpread({}, pagePathContent), targetType === 'text/markdown' ? {
            markdown: action.data
          } : {}), {}, {
            html: action.data,
            targetType: (_targetType = targetType) !== null && _targetType !== void 0 ? _targetType : 'text/html'
          })))))
        });
      }
    case actions.FETCH_PAGE_MD_SUCCESS:
      pagePathContent = getPreviewsPageContent();
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, _objectSpread(_objectSpread({}, pagePathContent), {}, {
          markdown: action.data
        })))))
      });
    case actions.PAGE_PATH_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          pageEditorState: {
            hasUnsavedChanges: false,
            pagePath: action.pagePath,
            pageName: null,
            groupId: null,
            assetId: null,
            version: null,
            pageContent: null
          }
        })
      });
    case actions.CREATE_PAGE.REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, {
          name: action.pageName,
          path: action.pagePath,
          markdown: '',
          html: '',
          isDisabled: true
        })))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isCreatingPage: true
        })
      });
    case actions.CREATE_PAGE.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, (0, _objects.omit)((_state$data$versionPa2 = state.data[versionPath]) !== null && _state$data$versionPa2 !== void 0 ? _state$data$versionPa2 : {}, action.initialPath)), {}, (0, _defineProperty2.default)({}, action.pagePath, {
          name: action.pageName,
          path: action.pagePath,
          markdown: '',
          html: '',
          isDisabled: false
        })))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isCreatingPage: false
        })
      });
    case actions.CREATE_PAGE.FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread({}, (0, _objects.omit)(state.data[versionPath], action.pagePath)))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isCreatingPage: false
        })
      });
    case actions.RENAME_PAGE.REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.oldPagePath, _objectSpread(_objectSpread({}, state.data[versionPath][action.oldPagePath]), {}, {
          isRenamed: true
        }))))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: true
        })
      });
    case actions.RENAME_PAGE.FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, (0, _objects.omit)(state.data[versionPath], action.pagePath)), {}, (0, _defineProperty2.default)({}, action.oldPagePath, action.oldPage))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: false
        })
      });
    case actions.RENAME_PAGE.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, (0, _objects.omit)(state.data[versionPath], action.oldPagePath)), {}, (0, _defineProperty2.default)({}, action.pagePath, _objectSpread(_objectSpread({}, action.oldPage), {}, {
          name: action.pageName,
          path: action.pagePath
        })))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: false
        })
      });
    case actions.DELETE_PAGE.REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, (0, _objects.omit)(state.data[versionPath], action.pagePath))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: true,
          pageEditorState: _objectSpread(_objectSpread({}, state.ui.pageEditorState), {}, {
            hasUnsavedChanges: false
          })
        })
      });
    case actions.DELETE_PAGE.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: false
        })
      });
    case actions.DELETE_PAGE.FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, action.page)))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: false
        })
      });
    case assetsActions.DELETE_ASSET.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread({}, (0, _objects.omit)(state.data, draftVersion, publishedVersion))
      });
    case actions.SAVE_PAGE.REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, _objectSpread(_objectSpread({}, state.data[versionPath] && state.data[versionPath][action.pagePath]), {}, {
          markdown: action.markdown,
          html: null
        }))))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: true
        })
      });
    case actions.SAVE_PAGE.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.pagePath, _objectSpread(_objectSpread({}, state.data[versionPath] && state.data[versionPath][action.pagePath]), {}, {
          html: action.html
        }))))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          pageEditorState: _objectSpread(_objectSpread({}, state.ui.pageEditorState), {}, {
            hasUnsavedChanges: false
          }),
          isLoading: false
        })
      });
    case actions.SET_PAGE_LOADING_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, versionPath, _objectSpread(_objectSpread({}, state.data[versionPath]), {}, (0, _defineProperty2.default)({}, action.params.pagePath, _objectSpread(_objectSpread({}, state.data[versionPath] && state.data[versionPath][action.params.pagePath]), {}, (0, _defineProperty2.default)({}, "".concat(action.params.contentType, "Error"), {
          message: action.error.message,
          status: action.error.status,
          requestId: action.error.requestId
        }))))))
      });
    case actions.SAVE_PAGE.FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoading: false
        })
      });
    case portalsActions.PUBLISH_PORTAL.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, publishedVersion, _objectSpread({}, state.data[draftVersion])))
      });
    case actions.UPDATE_PAGE_EDITOR_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          pageEditorState: {
            hasUnsavedChanges: action.hasUnsavedChanges,
            groupId: action.groupId,
            assetId: action.assetId,
            version: action.version,
            pagePath: action.pagePath,
            pageName: action.pageName,
            pageContent: action.pageContent
          }
        })
      });
    case actions.UPDATE_UNSAVED_CHANGES:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          hasUnsavedChanges: action.hasUnsavedChanges,
          pageEditorState: _objectSpread(_objectSpread({}, state.ui.pageEditorState), {}, {
            hasUnsavedChanges: false
          })
        })
      });
    case portalsActions.DISCARD_PORTAL_DRAFT.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          hasUnsavedChanges: false
        }),
        data: (0, _objects.omit)(state.data, draftVersion)
      });
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map